import axios from 'axios';
import jwt from 'jsonwebtoken';

// Cached variables
var tokenCache;
const apiKey = process.env.REACT_APP_API_KEY
const uri = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_VERSION;

// URL endpoints
const endpoint_contact = "contact";
const endpoint_user = "user";
const endpoint_authenticate = "authenticate";

export function getUsers() {
    axios.get(uri)
        .then(function (response) {
            // handle success
            console.log(response);
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        });
}

/**
 * Gets token from API and persists it in memory. 
 * Checks to see if token is still valid after persisting
 * 
 * NOTE!!! persistence is bugged! It gets a new token every time!
 */
function getToken() {

    let config = {
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey
        }
    }
    return new Promise((resolve, reject) => {
        // check if token is still valid
        jwt.verify(tokenCache, process.env.REACT_APP_API_KEY, (err, token) => {
            
            // if token expired request new one
            if (err) {
                // console.log('Token expired, requesting new one...');
                axios.post(uri + endpoint_authenticate, {}, config)
                    .then((res) => {
                        // The token   
                        tokenCache = token;             
                        resolve(res.data.token);
                    })
                    .catch((err) => {
                        console.log('an error occurred when authenticating');
                        reject(err);
                    });
            }
            else {
                // token still valid, continue as normal
                console.log('Loaded token from cache...');
                resolve(token);
            }
        });
    });
}

export function addUser(user, success, fail) {

    // get token the send request
    getToken()
        .then((token) => {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${token}`
                }
            }

            // Send add user request to API
            axios.post(uri + endpoint_user, user, config).then(function (response) {
                if(response.status === 200)
                {
                    console.log(response);
                    success();
                }else{
                    fail(response.status);
                }

            }).catch(function (error) {
                console.log(error);
                fail(error.response.status);
            });
        });
}

export function sendEnquiry(user, callback) {

    getToken()
        .then((token) => {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${token}`
                }
            }
            
            // POST send enquiry request to API
            axios.post(uri + endpoint_contact, user, config)
                .then(function (res) {
                    callback(undefined, res);
                }).catch((err) => {
                    console.log('an error occurred when speaking with User enquiry API Endpoint');
                    console.log(err);
                    callback(err);
                });
        })
        .catch((err) => {
            console.log('an error occurred when Sending the enquiry');
            console.log(err);
            callback(err);
        });

}


// WEBPACK FOOTER //
// ./src/components/synthcity/service/userwsao.js